import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { TipoCausalCausalSolicitud } from '../_models/tipo-causal-causal-solicitud';

@Injectable({
  providedIn: 'root'
})
export class TipoCausalCausalSolicitudService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/tiposCausalesCausalesSolicitudes';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as TipoCausalCausalSolicitud[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as TipoCausalCausalSolicitud[] ) );
  }

  listadoPorTipoCausal( idListaTipoCausalSolicitud: string ) {
    return this.httClient.get( this.rutServicio + '/tipoCausalSolicitud/' + idListaTipoCausalSolicitud ).pipe( map( res => res as TipoCausalCausalSolicitud[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as TipoCausalCausalSolicitud ) );
  }

  obtenerPorCausal( idCausalSolicitud: string ) {
    return this.httClient.get( this.rutServicio + '/' + idCausalSolicitud ).pipe( map( res => res as TipoCausalCausalSolicitud ) );
  }

  obtenerPorProductoYEstado( idProducto: string, idEstado: string ) {
    return this.httClient.get( this.rutServicio + '/estado/' + idEstado + '/producto/' + idProducto + '/enabled' )
      .pipe( map( res => res as TipoCausalCausalSolicitud[] ) );
  }

  crear( regCrear: TipoCausalCausalSolicitud ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TipoCausalCausalSolicitud ) );
  }

  actualizar( regActualizar: TipoCausalCausalSolicitud ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: TipoCausalCausalSolicitud[] ) {
    regActualizar.map( ( s: TipoCausalCausalSolicitud ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as TipoCausalCausalSolicitud[] ) );
  }
}
